/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddFairCandidateRequestDto } from '../models';
// @ts-ignore
import type { AddFairCandidatesRequestDto } from '../models';
// @ts-ignore
import type { AddFairCandidatesResponseDto } from '../models';
// @ts-ignore
import type { AdminActionRequestDto } from '../models';
// @ts-ignore
import type { CandidateProfileDto } from '../models';
// @ts-ignore
import type { CandidateSearchRequestDto } from '../models';
// @ts-ignore
import type { CandidateStatusCountsDto } from '../models';
// @ts-ignore
import type { CandidatesSearchResponseDto } from '../models';
// @ts-ignore
import type { ExportJobStatusResponseDto } from '../models';
// @ts-ignore
import type { FairCandidatesResponseDto } from '../models';
// @ts-ignore
import type { FairResultsResponseDto } from '../models';
// @ts-ignore
import type { QuizPointsLegendResponseDto } from '../models';
// @ts-ignore
import type { StartExportResponseDto } from '../models';
// @ts-ignore
import type { UpdateFairCandidateRequestDto } from '../models';
/**
 * RestAdminCandidatesApi - axios parameter creator
 * @export
 */
export const RestAdminCandidatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Manually add a candidate from a fair/trade show to the fair candidates list
         * @summary Add fair candidate
         * @param {string} adminUserId 
         * @param {AddFairCandidateRequestDto} addFairCandidateRequestDto Add fair candidate request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFairCandidate: async (adminUserId: string, addFairCandidateRequestDto: AddFairCandidateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('addFairCandidate', 'adminUserId', adminUserId)
            // verify required parameter 'addFairCandidateRequestDto' is not null or undefined
            assertParamExists('addFairCandidate', 'addFairCandidateRequestDto', addFairCandidateRequestDto)
            const localVarPath = `/api/admin/fair-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFairCandidateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add many fair candidates at once
         * @param {string} adminUserId 
         * @param {AddFairCandidatesRequestDto} addFairCandidatesRequestDto Add many fair candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFairCandidates: async (adminUserId: string, addFairCandidatesRequestDto: AddFairCandidatesRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('addFairCandidates', 'adminUserId', adminUserId)
            // verify required parameter 'addFairCandidatesRequestDto' is not null or undefined
            assertParamExists('addFairCandidates', 'addFairCandidatesRequestDto', addFairCandidatesRequestDto)
            const localVarPath = `/api/admin/fair-candidates/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addFairCandidatesRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download candidate\'s cv
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateCv: async (adminUserId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('downloadCandidateCv', 'adminUserId', adminUserId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('downloadCandidateCv', 'candidateId', candidateId)
            const localVarPath = `/api/admin/candidates/{candidateId}/cv`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download full candidate audit file
         * @param {string} adminUserId 
         * @param {string} email Candidate email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateFullAudit: async (adminUserId: string, email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('downloadCandidateFullAudit', 'adminUserId', adminUserId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('downloadCandidateFullAudit', 'email', email)
            const localVarPath = `/api/admin/candidates/audit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download candidate\'s process details
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateProcessCv: async (adminUserId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('downloadCandidateProcessCv', 'adminUserId', adminUserId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('downloadCandidateProcessCv', 'candidateId', candidateId)
            const localVarPath = `/api/admin/candidates/{candidateId}/process-details-file`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download generated full candidates export file
         * @param {string} adminUserId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidatesFullExport: async (adminUserId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('downloadCandidatesFullExport', 'adminUserId', adminUserId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('downloadCandidatesFullExport', 'jobId', jobId)
            const localVarPath = `/api/admin/candidates-full-export/{jobId}/download`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export quiz results as Excel file
         * @param {string} adminUserId 
         * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no lower limit
         * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no upper limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadQuizResultsExport: async (adminUserId: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('downloadQuizResultsExport', 'adminUserId', adminUserId)
            const localVarPath = `/api/admin/quiz-results-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the full profile of a candidate, with labels in the language of the request
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateProfile: async (adminUserId: string, candidateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getCandidateProfile', 'adminUserId', adminUserId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('getCandidateProfile', 'candidateId', candidateId)
            const localVarPath = `/api/admin/candidates/{candidateId}/profile`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Count all candidates by status, admin status and job fair origin
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateStatusCounts: async (adminUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getCandidateStatusCounts', 'adminUserId', adminUserId)
            const localVarPath = `/api/admin/candidates/status-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get candidates
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} adminUserId 
         * @param {CandidateSearchRequestDto} candidateSearchRequestDto Search candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidates: async (page: number, pageSize: number, adminUserId: string, candidateSearchRequestDto: CandidateSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getCandidates', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getCandidates', 'pageSize', pageSize)
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getCandidates', 'adminUserId', adminUserId)
            // verify required parameter 'candidateSearchRequestDto' is not null or undefined
            assertParamExists('getCandidates', 'candidateSearchRequestDto', candidateSearchRequestDto)
            const localVarPath = `/api/admin/candidates/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(candidateSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get status of a full candidates export job
         * @param {string} adminUserId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidatesFullExportStatus: async (adminUserId: string, jobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getCandidatesFullExportStatus', 'adminUserId', adminUserId)
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('getCandidatesFullExportStatus', 'jobId', jobId)
            const localVarPath = `/api/admin/candidates-full-export/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get fair candidates with pagination, with how far each of them got in the recruitment
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} adminUserId 
         * @param {string} [note] Only the candidates added with this note (e.g. the name of the fair)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCandidates: async (page: number, pageSize: number, adminUserId: string, note?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getFairCandidates', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getFairCandidates', 'pageSize', pageSize)
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getFairCandidates', 'adminUserId', adminUserId)
            const localVarPath = `/api/admin/fair-candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }

            if (note !== undefined) {
                localVarQueryParameter['note'] = note;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Results of every job fair, recognised by the note its candidates were added with
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairResults: async (adminUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getFairResults', 'adminUserId', adminUserId)
            const localVarPath = `/api/admin/fair-candidates/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get quiz points legend with thresholds and decisions
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizPointsLegend: async (adminUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('getQuizPointsLegend', 'adminUserId', adminUserId)
            const localVarPath = `/api/admin/quiz-points-legend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary invoke admin action
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {AdminActionRequestDto} adminActionRequestDto invoke admin action request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAdminAction: async (adminUserId: string, candidateId: string, adminActionRequestDto: AdminActionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('invokeAdminAction', 'adminUserId', adminUserId)
            // verify required parameter 'candidateId' is not null or undefined
            assertParamExists('invokeAdminAction', 'candidateId', candidateId)
            // verify required parameter 'adminActionRequestDto' is not null or undefined
            assertParamExists('invokeAdminAction', 'adminActionRequestDto', adminActionRequestDto)
            const localVarPath = `/api/admin/candidates/{candidateId}/execute-action`
                .replace(`{${"candidateId"}}`, encodeURIComponent(String(candidateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminActionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schedules a background job that produces an Excel file containing the candidates (all of them, or those registered in the period) with personal data, quiz results and skills.
         * @summary Start asynchronous full candidates export
         * @param {string} adminUserId 
         * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no lower limit
         * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no upper limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCandidatesFullExport: async (adminUserId: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('startCandidatesFullExport', 'adminUserId', adminUserId)
            const localVarPath = `/api/admin/candidates-full-export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update fair candidate email or note
         * @param {string} adminUserId 
         * @param {string} email Current email of the fair candidate
         * @param {UpdateFairCandidateRequestDto} updateFairCandidateRequestDto Update fair candidate request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFairCandidate: async (adminUserId: string, email: string, updateFairCandidateRequestDto: UpdateFairCandidateRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserId' is not null or undefined
            assertParamExists('updateFairCandidate', 'adminUserId', adminUserId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('updateFairCandidate', 'email', email)
            // verify required parameter 'updateFairCandidateRequestDto' is not null or undefined
            assertParamExists('updateFairCandidate', 'updateFairCandidateRequestDto', updateFairCandidateRequestDto)
            const localVarPath = `/api/admin/fair-candidates/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adminUserId !== undefined) {
                localVarQueryParameter['adminUserId'] = adminUserId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFairCandidateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestAdminCandidatesApi - functional programming interface
 * @export
 */
export const RestAdminCandidatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestAdminCandidatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Manually add a candidate from a fair/trade show to the fair candidates list
         * @summary Add fair candidate
         * @param {string} adminUserId 
         * @param {AddFairCandidateRequestDto} addFairCandidateRequestDto Add fair candidate request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFairCandidate(adminUserId: string, addFairCandidateRequestDto: AddFairCandidateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFairCandidate(adminUserId, addFairCandidateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.addFairCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add many fair candidates at once
         * @param {string} adminUserId 
         * @param {AddFairCandidatesRequestDto} addFairCandidatesRequestDto Add many fair candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addFairCandidates(adminUserId: string, addFairCandidatesRequestDto: AddFairCandidatesRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddFairCandidatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addFairCandidates(adminUserId, addFairCandidatesRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.addFairCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download candidate\'s cv
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidateCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidateCv(adminUserId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.downloadCandidateCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download full candidate audit file
         * @param {string} adminUserId 
         * @param {string} email Candidate email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidateFullAudit(adminUserId: string, email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidateFullAudit(adminUserId, email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.downloadCandidateFullAudit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download candidate\'s process details
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidateProcessCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidateProcessCv(adminUserId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.downloadCandidateProcessCv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Download generated full candidates export file
         * @param {string} adminUserId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCandidatesFullExport(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCandidatesFullExport(adminUserId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.downloadCandidatesFullExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export quiz results as Excel file
         * @param {string} adminUserId 
         * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no lower limit
         * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no upper limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadQuizResultsExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadQuizResultsExport(adminUserId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.downloadQuizResultsExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the full profile of a candidate, with labels in the language of the request
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateProfile(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateProfile(adminUserId, candidateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.getCandidateProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Count all candidates by status, admin status and job fair origin
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateStatusCounts(adminUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidateStatusCountsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateStatusCounts(adminUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.getCandidateStatusCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get candidates
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} adminUserId 
         * @param {CandidateSearchRequestDto} candidateSearchRequestDto Search candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidates(page: number, pageSize: number, adminUserId: string, candidateSearchRequestDto: CandidateSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CandidatesSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidates(page, pageSize, adminUserId, candidateSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.getCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get status of a full candidates export job
         * @param {string} adminUserId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidatesFullExportStatus(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExportJobStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidatesFullExportStatus(adminUserId, jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.getCandidatesFullExportStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get fair candidates with pagination, with how far each of them got in the recruitment
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} adminUserId 
         * @param {string} [note] Only the candidates added with this note (e.g. the name of the fair)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFairCandidates(page: number, pageSize: number, adminUserId: string, note?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FairCandidatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFairCandidates(page, pageSize, adminUserId, note, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.getFairCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Results of every job fair, recognised by the note its candidates were added with
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFairResults(adminUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FairResultsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFairResults(adminUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.getFairResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get quiz points legend with thresholds and decisions
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuizPointsLegend(adminUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizPointsLegendResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuizPointsLegend(adminUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.getQuizPointsLegend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary invoke admin action
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {AdminActionRequestDto} adminActionRequestDto invoke admin action request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invokeAdminAction(adminUserId: string, candidateId: string, adminActionRequestDto: AdminActionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invokeAdminAction(adminUserId, candidateId, adminActionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.invokeAdminAction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Schedules a background job that produces an Excel file containing the candidates (all of them, or those registered in the period) with personal data, quiz results and skills.
         * @summary Start asynchronous full candidates export
         * @param {string} adminUserId 
         * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no lower limit
         * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no upper limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCandidatesFullExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartExportResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCandidatesFullExport(adminUserId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.startCandidatesFullExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update fair candidate email or note
         * @param {string} adminUserId 
         * @param {string} email Current email of the fair candidate
         * @param {UpdateFairCandidateRequestDto} updateFairCandidateRequestDto Update fair candidate request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFairCandidate(adminUserId: string, email: string, updateFairCandidateRequestDto: UpdateFairCandidateRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFairCandidate(adminUserId, email, updateFairCandidateRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestAdminCandidatesApi.updateFairCandidate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestAdminCandidatesApi - factory interface
 * @export
 */
export const RestAdminCandidatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestAdminCandidatesApiFp(configuration)
    return {
        /**
         * Manually add a candidate from a fair/trade show to the fair candidates list
         * @summary Add fair candidate
         * @param {string} adminUserId 
         * @param {AddFairCandidateRequestDto} addFairCandidateRequestDto Add fair candidate request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFairCandidate(adminUserId: string, addFairCandidateRequestDto: AddFairCandidateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addFairCandidate(adminUserId, addFairCandidateRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add many fair candidates at once
         * @param {string} adminUserId 
         * @param {AddFairCandidatesRequestDto} addFairCandidatesRequestDto Add many fair candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFairCandidates(adminUserId: string, addFairCandidatesRequestDto: AddFairCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddFairCandidatesResponseDto> {
            return localVarFp.addFairCandidates(adminUserId, addFairCandidatesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download candidate\'s cv
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCandidateCv(adminUserId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download full candidate audit file
         * @param {string} adminUserId 
         * @param {string} email Candidate email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateFullAudit(adminUserId: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCandidateFullAudit(adminUserId, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download candidate\'s process details
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidateProcessCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCandidateProcessCv(adminUserId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download generated full candidates export file
         * @param {string} adminUserId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCandidatesFullExport(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCandidatesFullExport(adminUserId, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export quiz results as Excel file
         * @param {string} adminUserId 
         * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no lower limit
         * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no upper limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadQuizResultsExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadQuizResultsExport(adminUserId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the full profile of a candidate, with labels in the language of the request
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateProfile(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<CandidateProfileDto> {
            return localVarFp.getCandidateProfile(adminUserId, candidateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Count all candidates by status, admin status and job fair origin
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateStatusCounts(adminUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<CandidateStatusCountsDto> {
            return localVarFp.getCandidateStatusCounts(adminUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get candidates
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} adminUserId 
         * @param {CandidateSearchRequestDto} candidateSearchRequestDto Search candidates request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidates(page: number, pageSize: number, adminUserId: string, candidateSearchRequestDto: CandidateSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CandidatesSearchResponseDto> {
            return localVarFp.getCandidates(page, pageSize, adminUserId, candidateSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get status of a full candidates export job
         * @param {string} adminUserId 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidatesFullExportStatus(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobStatusResponseDto> {
            return localVarFp.getCandidatesFullExportStatus(adminUserId, jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get fair candidates with pagination, with how far each of them got in the recruitment
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} adminUserId 
         * @param {string} [note] Only the candidates added with this note (e.g. the name of the fair)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairCandidates(page: number, pageSize: number, adminUserId: string, note?: string, options?: RawAxiosRequestConfig): AxiosPromise<FairCandidatesResponseDto> {
            return localVarFp.getFairCandidates(page, pageSize, adminUserId, note, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Results of every job fair, recognised by the note its candidates were added with
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFairResults(adminUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<FairResultsResponseDto> {
            return localVarFp.getFairResults(adminUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get quiz points legend with thresholds and decisions
         * @param {string} adminUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuizPointsLegend(adminUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuizPointsLegendResponseDto> {
            return localVarFp.getQuizPointsLegend(adminUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary invoke admin action
         * @param {string} adminUserId 
         * @param {string} candidateId 
         * @param {AdminActionRequestDto} adminActionRequestDto invoke admin action request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invokeAdminAction(adminUserId: string, candidateId: string, adminActionRequestDto: AdminActionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.invokeAdminAction(adminUserId, candidateId, adminActionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Schedules a background job that produces an Excel file containing the candidates (all of them, or those registered in the period) with personal data, quiz results and skills.
         * @summary Start asynchronous full candidates export
         * @param {string} adminUserId 
         * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no lower limit
         * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no upper limit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCandidatesFullExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<StartExportResponseDto> {
            return localVarFp.startCandidatesFullExport(adminUserId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update fair candidate email or note
         * @param {string} adminUserId 
         * @param {string} email Current email of the fair candidate
         * @param {UpdateFairCandidateRequestDto} updateFairCandidateRequestDto Update fair candidate request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFairCandidate(adminUserId: string, email: string, updateFairCandidateRequestDto: UpdateFairCandidateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateFairCandidate(adminUserId, email, updateFairCandidateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestAdminCandidatesApi - interface
 * @export
 * @interface RestAdminCandidatesApi
 */
export interface RestAdminCandidatesApiInterface {
    /**
     * Manually add a candidate from a fair/trade show to the fair candidates list
     * @summary Add fair candidate
     * @param {string} adminUserId 
     * @param {AddFairCandidateRequestDto} addFairCandidateRequestDto Add fair candidate request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    addFairCandidate(adminUserId: string, addFairCandidateRequestDto: AddFairCandidateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Add many fair candidates at once
     * @param {string} adminUserId 
     * @param {AddFairCandidatesRequestDto} addFairCandidatesRequestDto Add many fair candidates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    addFairCandidates(adminUserId: string, addFairCandidatesRequestDto: AddFairCandidatesRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<AddFairCandidatesResponseDto>;

    /**
     * 
     * @summary Download candidate\'s cv
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    downloadCandidateCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Download full candidate audit file
     * @param {string} adminUserId 
     * @param {string} email Candidate email address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    downloadCandidateFullAudit(adminUserId: string, email: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Download candidate\'s process details
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    downloadCandidateProcessCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Download generated full candidates export file
     * @param {string} adminUserId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    downloadCandidatesFullExport(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Export quiz results as Excel file
     * @param {string} adminUserId 
     * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no lower limit
     * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no upper limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    downloadQuizResultsExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * 
     * @summary Get the full profile of a candidate, with labels in the language of the request
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    getCandidateProfile(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig): AxiosPromise<CandidateProfileDto>;

    /**
     * 
     * @summary Count all candidates by status, admin status and job fair origin
     * @param {string} adminUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    getCandidateStatusCounts(adminUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<CandidateStatusCountsDto>;

    /**
     * 
     * @summary get candidates
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} adminUserId 
     * @param {CandidateSearchRequestDto} candidateSearchRequestDto Search candidates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    getCandidates(page: number, pageSize: number, adminUserId: string, candidateSearchRequestDto: CandidateSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CandidatesSearchResponseDto>;

    /**
     * 
     * @summary Get status of a full candidates export job
     * @param {string} adminUserId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    getCandidatesFullExportStatus(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExportJobStatusResponseDto>;

    /**
     * 
     * @summary Get fair candidates with pagination, with how far each of them got in the recruitment
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} adminUserId 
     * @param {string} [note] Only the candidates added with this note (e.g. the name of the fair)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    getFairCandidates(page: number, pageSize: number, adminUserId: string, note?: string, options?: RawAxiosRequestConfig): AxiosPromise<FairCandidatesResponseDto>;

    /**
     * 
     * @summary Results of every job fair, recognised by the note its candidates were added with
     * @param {string} adminUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    getFairResults(adminUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<FairResultsResponseDto>;

    /**
     * 
     * @summary Get quiz points legend with thresholds and decisions
     * @param {string} adminUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    getQuizPointsLegend(adminUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuizPointsLegendResponseDto>;

    /**
     * 
     * @summary invoke admin action
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {AdminActionRequestDto} adminActionRequestDto invoke admin action request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    invokeAdminAction(adminUserId: string, candidateId: string, adminActionRequestDto: AdminActionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Schedules a background job that produces an Excel file containing the candidates (all of them, or those registered in the period) with personal data, quiz results and skills.
     * @summary Start asynchronous full candidates export
     * @param {string} adminUserId 
     * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no lower limit
     * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no upper limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    startCandidatesFullExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<StartExportResponseDto>;

    /**
     * 
     * @summary Update fair candidate email or note
     * @param {string} adminUserId 
     * @param {string} email Current email of the fair candidate
     * @param {UpdateFairCandidateRequestDto} updateFairCandidateRequestDto Update fair candidate request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApiInterface
     */
    updateFairCandidate(adminUserId: string, email: string, updateFairCandidateRequestDto: UpdateFairCandidateRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestAdminCandidatesApi - object-oriented interface
 * @export
 * @class RestAdminCandidatesApi
 * @extends {BaseAPI}
 */
export class RestAdminCandidatesApi extends BaseAPI implements RestAdminCandidatesApiInterface {
    /**
     * Manually add a candidate from a fair/trade show to the fair candidates list
     * @summary Add fair candidate
     * @param {string} adminUserId 
     * @param {AddFairCandidateRequestDto} addFairCandidateRequestDto Add fair candidate request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public addFairCandidate(adminUserId: string, addFairCandidateRequestDto: AddFairCandidateRequestDto, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).addFairCandidate(adminUserId, addFairCandidateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add many fair candidates at once
     * @param {string} adminUserId 
     * @param {AddFairCandidatesRequestDto} addFairCandidatesRequestDto Add many fair candidates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public addFairCandidates(adminUserId: string, addFairCandidatesRequestDto: AddFairCandidatesRequestDto, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).addFairCandidates(adminUserId, addFairCandidatesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download candidate\'s cv
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public downloadCandidateCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).downloadCandidateCv(adminUserId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download full candidate audit file
     * @param {string} adminUserId 
     * @param {string} email Candidate email address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public downloadCandidateFullAudit(adminUserId: string, email: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).downloadCandidateFullAudit(adminUserId, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download candidate\'s process details
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public downloadCandidateProcessCv(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).downloadCandidateProcessCv(adminUserId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download generated full candidates export file
     * @param {string} adminUserId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public downloadCandidatesFullExport(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).downloadCandidatesFullExport(adminUserId, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export quiz results as Excel file
     * @param {string} adminUserId 
     * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no lower limit
     * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate finished the quiz; without it there is no upper limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public downloadQuizResultsExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).downloadQuizResultsExport(adminUserId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the full profile of a candidate, with labels in the language of the request
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public getCandidateProfile(adminUserId: string, candidateId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).getCandidateProfile(adminUserId, candidateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Count all candidates by status, admin status and job fair origin
     * @param {string} adminUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public getCandidateStatusCounts(adminUserId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).getCandidateStatusCounts(adminUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get candidates
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} adminUserId 
     * @param {CandidateSearchRequestDto} candidateSearchRequestDto Search candidates request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public getCandidates(page: number, pageSize: number, adminUserId: string, candidateSearchRequestDto: CandidateSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).getCandidates(page, pageSize, adminUserId, candidateSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get status of a full candidates export job
     * @param {string} adminUserId 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public getCandidatesFullExportStatus(adminUserId: string, jobId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).getCandidatesFullExportStatus(adminUserId, jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get fair candidates with pagination, with how far each of them got in the recruitment
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} adminUserId 
     * @param {string} [note] Only the candidates added with this note (e.g. the name of the fair)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public getFairCandidates(page: number, pageSize: number, adminUserId: string, note?: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).getFairCandidates(page, pageSize, adminUserId, note, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Results of every job fair, recognised by the note its candidates were added with
     * @param {string} adminUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public getFairResults(adminUserId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).getFairResults(adminUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get quiz points legend with thresholds and decisions
     * @param {string} adminUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public getQuizPointsLegend(adminUserId: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).getQuizPointsLegend(adminUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary invoke admin action
     * @param {string} adminUserId 
     * @param {string} candidateId 
     * @param {AdminActionRequestDto} adminActionRequestDto invoke admin action request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public invokeAdminAction(adminUserId: string, candidateId: string, adminActionRequestDto: AdminActionRequestDto, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).invokeAdminAction(adminUserId, candidateId, adminActionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schedules a background job that produces an Excel file containing the candidates (all of them, or those registered in the period) with personal data, quiz results and skills.
     * @summary Start asynchronous full candidates export
     * @param {string} adminUserId 
     * @param {string} [from] First day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no lower limit
     * @param {string} [to] Last day (inclusive, Europe/Warsaw) of the period in which the candidate registered; without it there is no upper limit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public startCandidatesFullExport(adminUserId: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).startCandidatesFullExport(adminUserId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update fair candidate email or note
     * @param {string} adminUserId 
     * @param {string} email Current email of the fair candidate
     * @param {UpdateFairCandidateRequestDto} updateFairCandidateRequestDto Update fair candidate request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestAdminCandidatesApi
     */
    public updateFairCandidate(adminUserId: string, email: string, updateFairCandidateRequestDto: UpdateFairCandidateRequestDto, options?: RawAxiosRequestConfig) {
        return RestAdminCandidatesApiFp(this.configuration).updateFairCandidate(adminUserId, email, updateFairCandidateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

